module.exports = __webpack_public_path__ + "img/6_Distal Ascending Colon.2c72f865.png";